import React, { useEffect, useState, useRef } from 'react';
import { BookOpenIcon, CheckCircle2Icon, FileTextIcon, Globe2Icon, LockIcon, ShieldCheckIcon, SparklesIcon, StarIcon, ZapIcon } from 'lucide-react';
const shortTestimonials = [{
  quote: 'Antes de cada sesión revisaba videos para recordar el orden. Ahora abro el tomo, elijo el protocolo y empiezo. Mis clientas lo notan.',
  name: 'Sofía M.',
  role: 'Maderoterapista independiente, México'
}, {
  quote: 'Mis clientes empezaron a preguntarme si tenía algún paquete. Este trimestre vendí 6 programas de 8 sesiones.',
  name: 'Daniela R.',
  role: 'Dueña de centro wellness, Colombia'
}, {
  quote: 'El tomo de drenaje post-parto solo ya vale el precio completo. Es el servicio más demandado de mi agenda.',
  name: 'Valentina P.',
  role: 'Terapeuta corporal, España'
}];
export function Hero() {
  const ctaAnchorRef = useRef<HTMLDivElement>(null);
  const [showStickyCta, setShowStickyCta] = useState(true);
  useEffect(() => {
    const ctaAnchor = ctaAnchorRef.current;
    if (!ctaAnchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const hasNotReachedInlineCta = !entry.isIntersecting && entry.boundingClientRect.top > 0;
      setShowStickyCta(hasNotReachedInlineCta);
    }, {
      threshold: 0.15
    });
    observer.observe(ctaAnchor);
    return () => observer.disconnect();
  }, []);
  return <>
      <header className="w-full bg-cream px-4 pt-4 sm:px-6" data-id="element-55">
        <div className="mx-auto flex max-w-6xl items-center justify-between border-b border-brand-100 pb-3" data-id="element-56">
          <p className="text-xs font-extrabold tracking-[0.13em] text-brand-900" data-id="element-57">
            MEGAPACK MADEROTERAPIA PRO™
          </p>
          <span className="hidden text-xs font-semibold text-brand-600 sm:block" data-id="element-58">
            Material profesional en español
          </span>
        </div>
      </header>

      <main data-id="element-59">
        <section className="w-full bg-cream px-4 pb-7 pt-5 sm:px-6 md:pb-12 md:pt-8" data-id="element-60">
          <div className="mx-auto max-w-3xl" data-id="element-61">
            <div className="text-center" data-id="element-62">
              <div className="inline-flex items-center gap-2 rounded-full border border-accent/40 bg-accent/10 px-3 py-1.5 text-[11px] font-bold leading-tight text-brand-700 sm:text-xs" data-id="element-63">
                <SparklesIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-64" />
                La eligen profesionales del bienestar de todo el mundo hispano
              </div>

              <h1 className="mt-4 text-[2.15rem] font-bold leading-[1.03] tracking-tight text-brand-900 sm:text-5xl" data-id="element-65">
                Todos tus protocolos de maderoterapia.
                <span className="block italic text-brand-600" data-id="element-66">
                  Resueltos en menos de 5 minutos.
                </span>
              </h1>

              <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-gray-600 sm:text-base md:text-lg" data-id="element-67">
                La guía completa del maderoterapista profesional en español — 6
                tomos listos, protocolos por zona, fichas, guiones y sistema de
                negocio.{' '}
                <strong className="text-brand-900" data-id="element-68">Todo hecho por ti.</strong>
              </p>

              <div className="mt-4 flex flex-wrap justify-center gap-x-3 gap-y-2 text-xs font-semibold text-brand-800" data-id="element-69">
                <span className="flex items-center gap-1" data-id="element-70">
                  <BookOpenIcon className="h-4 w-4 text-brand-500" data-id="element-71" />6 Tomos
                </span>
                <span className="flex items-center gap-1" data-id="element-72">
                  <SparklesIcon className="h-4 w-4 text-brand-500" data-id="element-73" />5 Bonos
                </span>
                <span className="flex items-center gap-1" data-id="element-74">
                  <FileTextIcon className="h-4 w-4 text-brand-500" data-id="element-75" />
                  300+ páginas
                </span>
                <span className="flex items-center gap-1" data-id="element-76">
                  <CheckCircle2Icon className="h-4 w-4 text-brand-500" data-id="element-77" />8
                  herramientas
                </span>
              </div>

              <div className="mx-auto mt-5 w-full max-w-md" data-id="element-78">
                <img src="https://cdn.magicpatterns.com/uploads/8U48fKTRxNnpTgaKCD9DzM/hf_20260709_234754_2ec4c90d-3b24-46e7-b38c-c9af1900736c.png" alt="MegaPack Maderoterapia Pro con seis tomos y bonos incluidos" className="w-full rounded-xl border border-brand-100 bg-white shadow-xl shadow-brand-900/10" data-id="element-79" />
              </div>

              <div ref={ctaAnchorRef} className="mx-auto mt-5 w-full max-w-md md:mt-6" data-id="element-80">
                <a href="#pricing" className="flex w-full items-center justify-center rounded-lg bg-brand-600 px-5 py-4 text-sm font-bold text-white shadow-lg shadow-brand-900/15 transition-colors hover:bg-brand-700 focus:outline-none focus:ring-4 focus:ring-brand-500/30" data-id="element-81">
                  QUIERO MI MEGAPACK AHORA — SOLO $19 USD
                </a>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-x-3 gap-y-1.5 text-[11px] font-medium text-gray-500" data-id="element-82">
                <span className="flex items-center gap-1" data-id="element-83">
                  <LockIcon className="h-3.5 w-3.5" data-id="element-84" />
                  Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-85">
                  <ZapIcon className="h-3.5 w-3.5" data-id="element-86" />
                  Acceso inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-87">
                  <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-88" />
                  Garantía de 7 días
                </span>
                <span data-id="element-89">100% PDF</span>
              </div>
            </div>
          </div>
        </section>

        <section className="border-y border-brand-100 bg-white px-4 py-5 sm:px-6" data-id="element-90">
          <div className="mx-auto grid max-w-6xl grid-cols-2 gap-4 text-center md:grid-cols-4" data-id="element-91">
            {[['+800', 'profesionales'], ['6 tomos + 5', 'bonos incluidos'], ['4.9/5', 'valoración'], ['Todo el mundo', 'hispanohablante']].map(([value, label]) => <div key={label} className="border-brand-100 even:border-l md:border-l" data-id="element-92">
                <p className="text-lg font-black text-brand-900 sm:text-xl" data-id="element-93">
                  {value}
                </p>
                <p className="mt-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500" data-id="element-94">
                  {label}
                </p>
              </div>)}
          </div>
        </section>

        <section className="bg-white px-4 py-10 sm:px-6 md:py-16" data-id="element-95">
          <div className="mx-auto max-w-6xl" data-id="element-96">
            <div className="mb-7 text-center" data-id="element-97">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-98">
                Experiencias profesionales
              </p>
              <h2 className="mt-2 text-2xl font-black text-brand-900 md:text-3xl" data-id="element-99">
                De la improvisación a un protocolo claro
              </h2>
            </div>
            <div className="grid gap-4 md:grid-cols-3" data-id="element-100">
              {shortTestimonials.map(testimonial => <article key={testimonial.name} className="rounded-2xl border border-brand-100 bg-cream p-5" data-id="element-101">
                  <div className="flex gap-0.5 text-accent" aria-label="5 de 5 estrellas" data-id="element-102">
                    {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-103" />)}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-gray-700" data-id="element-104">
                    “{testimonial.quote}”
                  </blockquote>
                  <footer className="mt-4 border-t border-brand-100 pt-3" data-id="element-105">
                    <p className="text-sm font-bold text-brand-900" data-id="element-106">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-107">{testimonial.role}</p>
                  </footer>
                </article>)}
            </div>
          </div>
        </section>
      </main>

      <div className={`pointer-events-none fixed inset-x-0 bottom-0 z-50 px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-3 transition-[opacity,transform] duration-300 ease-out motion-reduce:transition-none ${showStickyCta ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`} aria-hidden={!showStickyCta} data-id="element-108">
        <a href="#pricing" tabIndex={showStickyCta ? 0 : -1} className="pointer-events-auto mx-auto flex w-full max-w-md items-center justify-center rounded-lg bg-brand-600 px-5 py-4 text-center text-sm font-bold text-white shadow-xl shadow-brand-900/20 transition-colors hover:bg-brand-700 focus:outline-none focus:ring-4 focus:ring-brand-500/30" data-id="element-109">
          QUIERO MI MEGAPACK AHORA — SOLO $19 USD
        </a>
      </div>
    </>;
}